export const TEST_PARTNER_ID_LIST = ['memberQA', 'nmemberQA']
